  import { useEffect, useMemo, useState,useContext} from 'react';
  import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
  import axios from 'axios'
  import {Menu,Paper} from '@mantine/core'
  import axiosInstance from '../../axios'
import AuthContext from '../../AuthContext'
  import { useNavigate } from 'react-router-dom';
  const Example = ({updateProductModalSetting ,handlePageUpdate}) => {
    const {userType}=useContext(AuthContext)
    const navigate=useNavigate()
    const columns = useMemo(
      () => [
      
        { 
          accessorKey: 'vtp_no',
          header: 'SIP ID',
          size: 150,
        },
        {
          accessorKey: 'vtp_id',
          header: 'VTP ID',
          size: 150,
        },
        {
          accessorKey: 'centre_name',
          header: 'Centre Name',
          size: 150,
        },
        {
          accessorKey: 'centre_address',
          header: 'Centre Address',
          size: 200,
        },

        {
          accessorKey: 'pin_code',
          header: 'Pin Code',
          size: 100,

        },
        {
          accessorKey: 'state',
          header: 'State',
          size: 150,

        },
        {
          accessorKey: 'district',
          header: 'District',
          size: 150,

        },
        {
          accessorKey: 'city',
          header: 'City',
          size: 150,

        },

        {
          accessorKey: 'pmkvy_partner',
          header: 'Partner Agency',
          size: 150,
        },
        {
          accessorKey: 'financial_year',
          header: 'Financial Year',
          size: 150,
        },
        {
          accessorKey: 'cp_name',
          header: 'Contact Person Name',
          size: 150,
        },
        {
          accessorKey: 'cp_email',
          header: 'Contact Person Email',
          size: 250,
        },
        {
          accessorKey: 'cp_mo_no',
          header: 'Contact Person Mobile',
          size: 250,
        },
        {
          accessorKey:'pan_no',
          header: 'PAN No.',
          size: 150,
        },
        {
          accessorKey: 'tan_no',
          header: 'TAN No.',
          size: 150,
        }
        ,{
          accessorKey: 'scheme_names',
          header: 'Scheme Names',
          size: 150,
        }
      ],
      [],
    );


    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sorting, setSorting] = useState([]); 

    useEffect(() => {
      axiosInstance.get(`/trainingcentre/getall`)
      .then((res) => setData(res.data.centres))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
    }, [handlePageUpdate]);

  const table=useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
       {userType!=='Accounts'&& 
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>}
        <Menu.Item onClick={() => navigate(
          `/centre/details`,{state:{id:row.original.centre_id}},
          { replace: true }
        )}>Details</Menu.Item>
      </>
    ),

  })

    return <Paper shadow="sm" p="lg" withBorder>
            <div style={{width: '100%' }}>

    <MantineReactTable
      table={table}
      striped // Enables the striped rows
      highlightOnHover
      horizontalSpacing="md"
      verticalSpacing="sm"
      fontSize="sm"
      withColumnBorders
      borderRadius="md"
      withGlobalFilter
      height={400}
      enablePagination={true} // Enables pagination
    />
    </div>
  </Paper>
  };

  export default Example;